import React from 'react'
import PropTypes from 'prop-types'
import { BrandsImage, BrandsMain, BrandsTitle } from './index.style'
import Container from '@components/Container'
import Spacer from '@components/Spacer'
import { GatsbyImage } from 'gatsby-plugin-image'
import BrandsGrid from '../BrandsGrid'
import { Caption } from '@components/TextStyles'
import { colors } from '@styles/vars/colors.style'

const Brands = ({ images }) => {

  const carouselItems = images.map(brand => (
    <BrandsImage>
      <GatsbyImage image={brand.gatsbyImageData} alt={brand.description} height="170" width="170" />
    </BrandsImage>
  ))

  const background = colors.charcoal
  const color = colors.white

  return (
    <BrandsMain color={color} background={background} >
      <Container>
        <Spacer size={[60, 90]} />
        <BrandsTitle><Caption>SHARED CLIENTS</Caption></BrandsTitle>
        <BrandsGrid items={carouselItems} itemsPerRow={3} />
        <Spacer size={[60, 90]} />
      </Container>
    </BrandsMain>
  )
}

Brands.propTypes = {
  images: PropTypes.array,
}

export default Brands
